// =============================================================================
// AUTO-GENERATED — do not edit by hand.
// Run `npm run icons:generate` (also wired into `prebuild` and `predev`)
// to refresh after adding or removing files in
// `src/components/atoms/Icon/Components/`.
// =============================================================================

export type IconName =
  | 'alert-circle'
  | 'alert-circle-solid'
  | 'alert-octagon'
  | 'alert-triangle'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-up'
  | 'arrow-up-right'
  | 'at-sign'
  | 'bell'
  | 'bookmark'
  | 'building'
  | 'calendar'
  | 'check'
  | 'check-circle'
  | 'check-circle-outline'
  | 'check-circle-solid'
  | 'chevron-down'
  | 'chevron-left'
  | 'chevron-left-double'
  | 'chevron-right'
  | 'chevron-right-double'
  | 'chevron-up'
  | 'chevron-up-double'
  | 'clock'
  | 'copy'
  | 'corner-up-left'
  | 'download-01'
  | 'edit'
  | 'eye'
  | 'eye-off'
  | 'file-stack'
  | 'file-text'
  | 'filter'
  | 'globe-02'
  | 'home'
  | 'inbox'
  | 'inbox-01'
  | 'info-circle'
  | 'info-square-solid'
  | 'leaf'
  | 'link'
  | 'link-01'
  | 'lock'
  | 'log-out'
  | 'mail'
  | 'marker-pin'
  | 'message-text-square'
  | 'minus'
  | 'minus-circle'
  | 'monitor'
  | 'moon'
  | 'more-horizontal'
  | 'oro-ai'
  | 'paperclip'
  | 'pause-circle'
  | 'payment-icon'
  | 'plus'
  | 'search'
  | 'send-01solid'
  | 'settings'
  | 'slash-circle'
  | 'sort'
  | 'sun'
  | 'user'
  | 'user-plus'
  | 'user-right'
  | 'x'
  | 'x-circle'
  | 'x-circle-solid'

export const iconNamesList: readonly IconName[] = [
  'alert-circle',
  'alert-circle-solid',
  'alert-octagon',
  'alert-triangle',
  'arrow-left',
  'arrow-right',
  'arrow-up',
  'arrow-up-right',
  'at-sign',
  'bell',
  'bookmark',
  'building',
  'calendar',
  'check',
  'check-circle',
  'check-circle-outline',
  'check-circle-solid',
  'chevron-down',
  'chevron-left',
  'chevron-left-double',
  'chevron-right',
  'chevron-right-double',
  'chevron-up',
  'chevron-up-double',
  'clock',
  'copy',
  'corner-up-left',
  'download-01',
  'edit',
  'eye',
  'eye-off',
  'file-stack',
  'file-text',
  'filter',
  'globe-02',
  'home',
  'inbox',
  'inbox-01',
  'info-circle',
  'info-square-solid',
  'leaf',
  'link',
  'link-01',
  'lock',
  'log-out',
  'mail',
  'marker-pin',
  'message-text-square',
  'minus',
  'minus-circle',
  'monitor',
  'moon',
  'more-horizontal',
  'oro-ai',
  'paperclip',
  'pause-circle',
  'payment-icon',
  'plus',
  'search',
  'send-01solid',
  'settings',
  'slash-circle',
  'sort',
  'sun',
  'user',
  'user-plus',
  'user-right',
  'x',
  'x-circle',
  'x-circle-solid',
] as const
